import { Styled } from "./styles";
import { withErrorBoundary } from "@/components/hoc";
import SettingsComponent from "@/components/settings";
import useQueryOrganization from "@/hooks/queries/useQueryOrganization";
import useQuerySubscription from "@/hooks/queries/useQuerySubscription";

const Settings: React.FC = () => {
    const { data: organization } = useQueryOrganization();
    const { data: subscription } = useQuerySubscription();

    if (!organization || !subscription) return <Styled.Container />;

    return (
        <Styled.Container>
            <SettingsComponent organization={organization} subscription={subscription} />
        </Styled.Container>
    );
};

export default withErrorBoundary({ component: "Settings" })(Settings);
